import { create } from "zustand";
import { persist } from "zustand/middleware";

type VisitedSitesWithoutCommonScriptStore = {
  sites: { publicId: string; expiresAt: number }[];
  addVisitedSite: (sitePublicId: string) => void;
};

export const useVisitedSitesWithoutCommonScript = create(
  persist<VisitedSitesWithoutCommonScriptStore>(
    (set) => ({
      sites: [],
      addVisitedSite: (sitePublicId) => {
        set((state) => ({
          sites: [
            // 기존 사이트 제거
            ...state.sites.filter((s) => s.publicId !== sitePublicId),
            {
              publicId: sitePublicId,
              expiresAt: new Date().setHours(24, 0, 0, 0),
            },
          ],
        }));
      },
    }),
    {
      name: "visitedSitesWithoutCommonScript",
    }
  )
);
